import { DealerUserRole } from "@/gql/graphql";
import { forgetRememberedAccounts } from "@/store/rememberedAccountsStorage";
import {
  readSupportAdminAuthFlagFromStorage,
  writeSupportAdminAuthFlagToStorage,
} from "@/store/supportAdminAuthStorage";
import { readSupportModeSessionFromStorage } from "@/store/supportModeSessionStorage";

export function isAccountIdAuthExcludedRole(role: DealerUserRole): boolean {
  return role === DealerUserRole.SupportAdmin;
  // SalesOrderAdmin: pending product-owner decision — add here if confirmed
}

export function shouldSkipAccountIdAuthorize(
  meRole?: DealerUserRole | null
): boolean {
  if (meRole != null) {
    return isAccountIdAuthExcludedRole(meRole);
  }

  if (readSupportModeSessionFromStorage() !== null) {
    return true;
  }

  if (readSupportAdminAuthFlagFromStorage()) {
    return true;
  }

  return false;
}

export function applyAccountIdAuthPolicyForRole(role: DealerUserRole): void {
  if (isAccountIdAuthExcludedRole(role)) {
    writeSupportAdminAuthFlagToStorage(true);
    forgetRememberedAccounts();
    return;
  }

  writeSupportAdminAuthFlagToStorage(false);
}
